import { Fieldset } from './fieldset';
import { Label } from './label';
import { OptionButton } from './option-button';

type DecisionButtonsProps = {
  label: string;
  options: { value: string; label: string }[];
  selected?: string[];
  onSelection: (value: string) => void;
  align?: 'center' | 'left';
  disabled?: boolean;
  helper?: {
    text: string;
    link: string;
  };
};

export function MultiDecisionButtons(props: DecisionButtonsProps) {
  const { label, selected, onSelection, align = 'center', options, helper, disabled } = props;

  return (
    <Fieldset>
      <Label className={align === 'center' ? 'text-center justify-center' : 'text-left'}>
        {label}
        {helper ? (
          <a
            href={helper.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary underline"
          >
            {helper.text}
          </a>
        ) : null}
      </Label>
      <div
        className={`flex flex-wrap gap-2 ${align === 'center' ? 'justify-center' : 'justify-start'}`}
      >
        {options.map((option) => (
          <OptionButton
            disabled={disabled}
            key={option.value}
            value={option.value}
            active={selected?.includes(option.value)}
            onClick={() => onSelection(option.value)}
          >
            {option.label}
          </OptionButton>
        ))}
      </div>
    </Fieldset>
  );
}
